import { ACCENT_CLASSES, type VacancyDef } from '../../../config/vacancies';

interface Props {
  vacancy: VacancyDef;
  onSelect: (route: string) => void;
}

export default function VacancyCard({ vacancy, onSelect }: Props) {
  const c = ACCENT_CLASSES[vacancy.accent];
  const isDisabled = !!vacancy.disabled;

  return (
    <div
      onClick={isDisabled ? undefined : () => onSelect(vacancy.route)}
      aria-disabled={isDisabled || undefined}
      className={`group relative bg-[#0e0e11] border rounded-2xl p-10 flex flex-col items-center text-center transition-all duration-300 ${
        isDisabled
          ? 'border-[#18181c] cursor-not-allowed'
          : `${c.border} ${c.borderHover} cursor-pointer hover:-translate-y-2`
      }`}
    >
      {(isDisabled || vacancy.badge) && (
        <div className="absolute top-4 right-4">
          <span
            className={`text-xs border rounded-full px-2.5 py-1 ${
              isDisabled
                ? 'text-foreground-400 bg-foreground-500/10 border-foreground-500/20'
                : c.badge
            }`}
          >
            {isDisabled ? 'Скоро' : vacancy.badge}
          </span>
        </div>
      )}

      <div
        className={`w-20 h-20 flex items-center justify-center rounded-2xl mb-6 transition-all duration-300 ${
          isDisabled ? 'opacity-40 grayscale' : 'group-hover:scale-110'
        }`}
        style={{ background: c.gradient }}
      >
        <i className={`${vacancy.icon} text-4xl ${isDisabled ? 'text-foreground-400' : c.iconText}`} />
      </div>

      <h2 className={`text-2xl font-bold mb-3 ${isDisabled ? 'text-foreground-600' : 'text-white'}`}>
        {vacancy.title}
      </h2>
      <p className={`text-sm leading-relaxed mb-8 ${isDisabled ? 'text-foreground-400' : 'text-foreground-500'}`}>
        {vacancy.description}
      </p>

      {isDisabled ? (
        <div className="mt-auto w-full flex items-center justify-center gap-2 rounded-xl border border-dashed border-[#26262c] bg-[#141417]/40 py-3 text-sm text-foreground-400 cursor-not-allowed">
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-lock-2-line" />
          </span>
          {vacancy.disabledNote ?? 'Набор временно закрыт'}
        </div>
      ) : (
        <button
          className={`mt-auto w-full rounded-xl py-3 text-sm transition-all duration-200 cursor-pointer whitespace-nowrap ${c.button}`}
        >
          {vacancy.buttonLabel}
        </button>
      )}
    </div>
  );
}
